//Icons
import bolsoIcon from './bolso-icon.png';
import delantalIcon from './delantal-icon.png';
import sombreroIcon from './sombrero-icon.png';
import gorraIcon from './gorra-icon.png';
import libretaIcon from './libreta-icon.png';

//Bolso gallery
import bolso1 from './bolso/bolso (1).jpg';
import bolso2 from './bolso/bolso (2).jpg';
import bolso3 from './bolso/bolso (3).jpg';
import bolso4 from './bolso/bolso (4).jpg';
import bolso5 from './bolso/bolso (5).jpg';
import bolso6 from './bolso/bolso (6).jpg';
import bolso7 from './bolso/bolso (7).jpg';
import bolso8 from './bolso/bolso (8).jpg';
import bolso9 from './bolso/bolso (9).jpg';
import bolso10 from './bolso/bolso (10).jpg';
import bolso11 from './bolso/bolso (11).jpg';
import bolso12 from './bolso/bolso (12).jpg';
import bolso13 from './bolso/bolso (13).jpg';
import bolso14 from './bolso/bolso (14).jpg';
import bolso15 from './bolso/bolso (15).jpg';
import bolso16 from './bolso/bolso (16).jpg';
import bolso17 from './bolso/bolso (17).jpg';
import bolso18 from './bolso/bolso (18).jpg';
import bolso19 from './bolso/bolso (19).jpg';
import bolso20 from './bolso/bolso (20).jpg';
import bolso21 from './bolso/bolso (21).jpg';
import bolso22 from './bolso/bolso (22).jpg';
import bolso23 from './bolso/bolso (23).jpg';
import bolso24 from './bolso/bolso (24).jpg';
import bolso25 from './bolso/bolso (25).jpg';
import bolso26 from './bolso/bolso (26).jpg';
import bolso27 from './bolso/bolso (27).jpg';
import bolso28 from './bolso/bolso (28).jpg';
import bolso29 from './bolso/bolso (29).jpg';
import bolso30 from './bolso/bolso (30).jpg';
import bolso31 from './bolso/bolso (31).jpg';
import bolso32 from './bolso/bolso (32).jpg';
import bolso33 from './bolso/bolso (33).jpg';
import bolso34 from './bolso/bolso (34).jpg';
import bolso35 from './bolso/bolso (35).jpg';
import bolso36 from './bolso/bolso (36).jpg';
import bolso37 from './bolso/bolso (37).jpg';
import bolso38 from './bolso/bolso (38).jpg';
import bolso39 from './bolso/bolso (39).jpg';
import bolso40 from './bolso/bolso (40).jpg';
import bolso41 from './bolso/bolso (41).jpg';
import bolso42 from './bolso/bolso (42).jpg';

//Delantal gallery
import delantal1 from './delantal/delantal (1).jpg';
import delantal2 from './delantal/delantal (2).jpg';
import delantal3 from './delantal/delantal (3).jpg';
import delantal4 from './delantal/delantal (4).jpg';
import delantal5 from './delantal/delantal (5).jpg';
import delantal6 from './delantal/delantal (6).jpg';
import delantal7 from './delantal/delantal (7).jpg';
import delantal8 from './delantal/delantal (8).jpg';
import delantal9 from './delantal/delantal (9).jpg';
import delantal10 from './delantal/delantal (10).jpg';
import delantal11 from './delantal/delantal (11).jpg';

//Gorra gallery
import gorra1 from './gorra/gorra (1).png';
import gorra2 from './gorra/gorra (2).png';
import gorra3 from './gorra/gorra (3).png';
import gorra4 from './gorra/gorra (4).png';
import gorra5 from './gorra/gorra (5).png';
import gorra6 from './gorra/gorra (6).png';
import gorra7 from './gorra/gorra (7).png';
import gorra8 from './gorra/gorra (8).png';
import gorra9 from './gorra/gorra (9).png';
import gorra10 from './gorra/gorra (10).png';
import gorra11 from './gorra/gorra (11).png';
import gorra12 from './gorra/gorra (12).png';
import gorra13 from './gorra/gorra (13).png';
import gorra14 from './gorra/gorra (14).png';

//Libreta gallery
import libreta1 from './libreta/libreta (1).JPG';
import libreta2 from './libreta/libreta (2).JPG';

//Sombrero gallery
import sombrero1 from './sombrero/sombrero (1).png';
import sombrero2 from './sombrero/sombrero (2).png';
import sombrero3 from './sombrero/sombrero (3).png';
import sombrero4 from './sombrero/sombrero (4).png';

export const GRID_DATA = {
    elements: [
        {
            id: 1,
            type: 'icon',
            title1: 'Tradición',
            title2: 'Venezolana',
            icon: bolsoIcon,
        },
        {
            id: 2,
            type: 'product',
            name: 'bolso',
            image: bolso1, 
            gallery: [
                bolso1,
                bolso2,
                bolso3,
                bolso4,
                bolso5,
                bolso6,
                bolso7,
                bolso8,
                bolso9,
                bolso10, 
                bolso11,
                bolso12,
                bolso13,
                bolso14,
                bolso15,
                bolso16,
                bolso17,
                bolso18,
                bolso19,
                bolso20, 
                bolso21,
                bolso22,
                bolso23,
                bolso24,
                bolso25,
                bolso26,
                bolso27,
                bolso28,
                bolso29,
                bolso30,
                bolso31,
                bolso32,
                bolso33,
                bolso34,
                bolso35,
                bolso36,
                bolso37,
                bolso38,
                bolso39,
                bolso40,
                bolso41,
                bolso42,
            ]
        },
        {
            id: 3,
            type: 'icon',
            title1: 'Símbolo',
            title2: 'Venezolano',
            icon: delantalIcon,
        },
        {
            id: 4,
            type: 'product',
            name: 'delantal',
            image: delantal1, 
            gallery: [
                delantal1,
                delantal2,
                delantal3,
                delantal4,
                delantal5,
                delantal6,
                delantal7,
                delantal8,
                delantal9,
                delantal10, 
                delantal11,
            ]
        },
        {
            id: 5,
            type: 'icon',
            title1: 'Fauna',
            title2: 'Venezolana',
            icon: gorraIcon,
        },
        {
            id: 6,
            type: 'product',
            name: 'gorra',
            image: gorra1, 
            gallery: [
                gorra1,
                gorra2,
                gorra3,
                gorra4,
                gorra5,
                gorra6,
                gorra7,
                gorra8,
                gorra9,
                gorra10, 
                gorra11,
                gorra12,
                gorra13,
                gorra14,
            ]
        },
        {
            id: 7,
            type: 'icon',
            title1: 'Turismo',
            title2: 'Venezolano',
            icon: sombreroIcon,
        },
        {
            id: 8,
            type: 'product',
            name: 'sombrero',
            image: sombrero1,
            gallery: [
                sombrero1,
                sombrero2,
                sombrero3,
                sombrero4
            ]
        },
        {
            id: 9,
            type: 'icon',
            title1: 'Llanura',
            title2: 'Venezolana',
            icon: libretaIcon
        },
        {
            id: 10,
            type: 'product',
            name: 'libreta',
            image: libreta1,
            gallery: [
                libreta1,
                libreta2,
            ]
        },
    ]
};